/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, creator: NonNullable<unknown> }} Agent_Access_Hidden_Dataset_PluralInputs */



/**
* | output |
* | --- |
* | "{count} datasets you can't see: ask {creator}." |
*
* @param {Agent_Access_Hidden_Dataset_PluralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_hidden_dataset_plural = /** @type {((inputs: Agent_Access_Hidden_Dataset_PluralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Hidden_Dataset_PluralInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Datensätze, die Sie nicht sehen können: Fragen Sie ${i?.creator}.`)
	return /** @type {LocalizedString} */ (`${i?.count} datasets you can't see: ask ${i?.creator}.`)
});